import { z } from 'zod'

// the remembered decision for one CSV category value. `create` is deliberately NOT part of the
// persisted union: a newly created category is rewritten to its real id before the dictionary is
// saved, or the next import would try to create the same category all over again.
export const importCategoryMappingActionSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('existing'), categoryId: z.string().guid() }),
  z.object({ type: z.literal('ignore') }),
])

export const importCategoryMappingEntrySchema = z.object({
  // the CSV category value, normalized (trimmed + lowercased) so a casing change in next month's
  // export does not silently create a second entry for the same bank category
  csvValue: z.string().min(1).max(200),
  action: importCategoryMappingActionSchema,
})

// stored under UserSettingKey.IMPORT_CATEGORY_MAPPING. expense and income categories are different
// sets, so each kind keeps its own dictionary — an income category can never surface in the expense
// import. kept as ordered arrays (least recently used first) rather than objects: the size guard
// drops the oldest entries, and JS object key order is not dependable for numeric-looking keys
// ("1000" and friends are perfectly ordinary bank category names).
export const importCategoryMappingSchema = z.object({
  expense: z.array(importCategoryMappingEntrySchema).max(500).default([]),
  income: z.array(importCategoryMappingEntrySchema).max(500).default([]),
})

export type ImportCategoryMappingActionDto = z.infer<typeof importCategoryMappingActionSchema>
export type ImportCategoryMappingEntryDto = z.infer<typeof importCategoryMappingEntrySchema>
export type ImportCategoryMappingDto = z.infer<typeof importCategoryMappingSchema>

export type ImportCategoryMappingKind = keyof ImportCategoryMappingDto
